import { hermesLogger } from '@core/observability'

import {
  Modules,
  PERMISSIONS,
  UserPermission,
} from '../user-permissions/user-permissions.types'

export const hasPermission = ({
  userPermission,
  module,
}: {
  userPermission?: UserPermission
  module: Modules
}) => {
  if (!userPermission) return false

  if (!PERMISSIONS[module]) {
    hermesLogger.error(
      `[Permissions - hasPermission] Module ${module} not found`
    )
    return false
  }

  return PERMISSIONS[module].includes(userPermission)
}
